import React, { useRef, useState } from 'react'

// 증빙 첨부 — 끌어다 놓거나 골라서 담고, 상신할 때 문서와 함께 올린다.
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024

const size = (n) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)}MB` : `${Math.max(1, Math.round(n / 1024))}KB`)

export default function AttachmentPicker({ files, onChange }) {
  const ref = useRef(null)
  const [over, setOver] = useState(false)

  const add = (picked) => {
    const next = [...files]
    for (const f of picked) {
      if (!next.some((x) => x.name === f.name && x.size === f.size)) next.push(f)
    }
    onChange(next)
  }

  const oversized = files.filter((f) => f.size > MAX_ATTACHMENT_BYTES)

  return (
    <>
      <div
        className={`drop-zone${over ? ' over' : ''}`}
        onClick={() => ref.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setOver(true) }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); add([...e.dataTransfer.files]) }}
      >
        파일을 끌어다 놓거나 클릭해서 선택하세요 · 파일당 10MB 이하
      </div>
      <input
        ref={ref} type="file" multiple style={{ display: 'none' }}
        onChange={(e) => { add([...e.target.files]); e.target.value = '' }}
      />
      {files.length > 0 && (
        <div className="attach-list">
          {files.map((f, i) => (
            <div key={`${f.name}-${i}`} className="attach-item">
              <span className="name">{f.name}</span>
              <span className={f.size > MAX_ATTACHMENT_BYTES ? 'warn' : 'muted'}>{size(f.size)}</span>
              <button className="btn danger" onClick={() => onChange(files.filter((_, j) => j !== i))}>삭제</button>
            </div>
          ))}
        </div>
      )}
      {oversized.length > 0 && (
        <div className="hint warn">10MB를 넘는 파일은 첨부할 수 없습니다: {oversized.map((f) => f.name).join(', ')}</div>
      )}
    </>
  )
}
